<template>
  <aw-form v-model="v$" @on-submit="onSubmitForm">
    <aw-form-row v-model="email" />
    <lv-grid type="row" gutter="sm">
      <lv-grid type="item" xs="1/1">
        <aw-form-button
          v-model="v$"
          :disabled="disabled"
          styling="primary-small-outlined"
          stretch
        >
          {{ $awt('aw.common.unsubscribe.unsubscribe_btn') }}
        </aw-form-button>
      </lv-grid>
    </lv-grid>
  </aw-form>
</template>

<script>

  import { useVuelidate } from '@vuelidate/core';

  import { email, required } from '@vuelidate/validators';
  import { LvGrid } from '~~/common/components/loginet-vue-shop/index';

  import AwForm from '~~/common/components/Form/AwForm';
  import AwFormRow from '~~/common/components/Form/AwFormRow';
  import AwFormButton from '~~/common/components/Form/AwFormButton';
  import { useNotificationStore } from '~~/common/stores/notification';

  export default {
    name: 'AwUnsubscribeForm',
    components: {
      AwFormButton,
      LvGrid,
      AwFormRow,
      AwForm,
    },
    setup: () => ({ v$: useVuelidate() }),
    validations: {
      email: {
        model: {
          required,
          email,
        },
      },
    },
    data () {
      return {
        disabled: false,
        email: {
          model: '',
          type: 'email',
          name: 'email',
          label: 'E-mail',
          isBoxError: false,
          tokens: {
            required: 'aw.common.unsubscribe.email_required',
          },
          labelAttrs: {
            for: 'email',
          },
          widgetAttrs: {
            id: 'email',
          },
        },
      };
    },
    methods: {
      async onSubmitForm () {
        try {
          this.disabled = true;

          await this.$api.post('/me/subscriptions/clear', {
            subscriptionType: 'all',
            subscriptionChannel: this.email.model,
          });
          const notificationStore = useNotificationStore();
          notificationStore.pushSuccess({
            manualClose: true,
            text: {
              titleToken: 'aw.common.unsubscribe.successfull_unsubscribe',
            },
          });
        } catch (err) {
          this.$logger.error(err);
        }
        this.disabled = false;
        this.email.model = '';
        this.v$.$reset();
      },
    },
  };
</script>

<style module lang="scss" rel="stylesheet/scss">
.newsletterCheckbox {
  * {
    font-weight: normal !important;
    cursor: default !important;
  }

  strong {
    font-weight: bold !important;
    cursor: unset !important;
  }

  a {
    font-weight: normal !important;
    cursor: pointer !important;
    color: $color-brand-secondary;

    &:hover,
    &:active,
    &:focus {
      text-decoration: underline !important;
      color: $color-brand-secondary-active;
    }
  }
}
</style>
